import { PropsWithChildren } from 'react';
import MediaQuery from 'react-responsive';
import styled from 'styled-components';

import { firefly, paradigmLightBlue } from '@paradigm/design-system/src/colors';

import { warningYellowIcon } from '#/assets';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import { DeskName } from '#/components/UnifiedRfqs/drfq/common';
import AnonEyeIcon from '@paradigm/design-system/src/assets/AnonEyeIcon';

export function WarningMessage({
  children,
  className,
}: PropsWithChildren & { className?: string }) {
  return (
    <WarningContainer className={className}>
      <WarningImg src={warningYellowIcon} alt="warning" />
      {children}
    </WarningContainer>
  );
}

export const AnonIconText = ({
  className,
  color = paradigmLightBlue,
  opacity = 1,
}: {
  color?: string;
  opacity?: number;
  className?: string;
}) => {
  return (
    <AnonText className={className} color={color} opacity={opacity}>
      <AnonEyeIcon fill={color} />
    </AnonText>
  );
};

export const AnonMessage = () => {
  return (
    <>
      <MediaQuery minWidth={MOBILE_BREAKPOINT}>
        Anonymous RFQ - Quotes will be&nbsp;
        <AnonIconText />. Maker Desk Name will only be revealed post-trade.
      </MediaQuery>
      <MediaQuery maxWidth={MOBILE_BREAKPOINT}>
        Anonymous RFQ - Quotes will be Anon. Maker Desk Name will only be
        revealed post-trade.
      </MediaQuery>
    </>
  );
};

const AnonText = styled(DeskName)<{ color: string; opacity: number }>`
  color: ${(props) => props.color};
  opacity: ${(props) => props.opacity};
  height: unset;
  justify-content: unset;
  font-size: 0.75rem;
  justify-content: center;
`;

const WarningImg = styled.img`
  margin-right: 0.5rem;
  width: 1rem;
`;

const WarningContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.75rem;
  background-color: ${firefly};
  padding: 0.5rem 0.75rem;
  border-radius: 1rem;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    position: relative;
    justify-content: center;
    margin-bottom: 1.25rem;
  }
`;
